import React from 'react';
import createSVG from './createSVG';

const DeleteIcon = ({style}) => (
  <path style={style} fill="none" fillRule="evenodd" stroke="#7D7D7D" strokeWidth="1.5" d="M20.42 25H5.08M24.5 1.5H1M23.712 6L20.42 24.82M1.786 6L5.08 24.82" strokeLinecap="round" strokeLinejoin="round"/>
);

export default createSVG(DeleteIcon);
